import PdfFluxoCaixa from "./PdfFluxoCaixa";

function PdfFluxoCaixaWrapper({ showPreviousPage, dados }) {
  const showPreviousP = () => {
    showPreviousPage();
  };

  return (
    <div>
      <PdfFluxoCaixa dados={dados.dados} showPreviousPage={showPreviousP} />
    </div>
  );
}

export default PdfFluxoCaixaWrapper;
